import orderInterruptedCreator from '@web/middlewares/orderInterrupted'

import {ResultRootState as State} from '../../../interfaces'

const orderInterruptedMiddleware = orderInterruptedCreator<State>()

/** orderInterrupted Action 관련 미들웨어  */
export default orderInterruptedMiddleware
